import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {CustomerAccountTraderDataLoadingService} from "./customer-account-trader-data-loading.service";
import {BatchUtils} from "../../../utils/batch-utils";
import {
  BatchActionAccountTraderFormComponent
} from "../../../crystal-clear/customer/account-trader/batch-update-form/batch-action-account-trader-form.component";
import TYPE = FormFieldConfig.TYPE;

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTraderBatchFormConfigService {

  fieldsToUpdate: string[] = [];

  constructor(private readonly dataLoadingService: CustomerAccountTraderDataLoadingService) {
  }

  public loadConfig(component: BatchActionAccountTraderFormComponent): FormFieldGroupConfig[] {

    return [
      {
        group: '',
        fields: [
          {
            field: 'owner',
            optionValue: 'text',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.dataLoadingService.owners,
            changed: event => {
              component.formRecord.owner = event.value;
              component.formRecord.customerName = undefined;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterCustomers(component.formRecord);
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.customerName = accountField.value.customerName;
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            },
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => {
              BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked);
              this.validate(component);
            },
            disabled: (record: any) => !this.fieldsToUpdate.includes('owner'),
            validate: record => this.validate(component)
          },
          {
            field: 'customerName',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            optionValue: 'text',
            options: () => this.dataLoadingService.displayedCustomers,
            changed: event => {
              component.formRecord.customerName = event.value;//this.customers.find(value => value.id ===event.value).text;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            },
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => {
              BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked);
              this.validate(component);
            },
            disabled: (record: any) => !this.fieldsToUpdate.includes('customerId'),
            validate: record => this.validate(component)
          },
          {
            field: 'exchangeCode',
            icon: (id: string) => {
              if (this.dataLoadingService.exchangeCodes) {
                const exchField = this.dataLoadingService.exchangeCodes.find(exchange => exchange.value && exchange.value.code === id);
                if (exchField && exchField.value)
                  return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              }
              return 'fas fa-globe-europe';
            },
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.dataLoadingService.exchangeCodes,
            changed: event => {
              component.formRecord.exchangeCode = event.value;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            },
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => {
              BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked);
              this.validate(component);
            },
            disabled: (record: any) => !this.fieldsToUpdate.includes('exchangeCode'),
            validate: record => this.validate(component)
          },
          {
            field: 'contractList',
            column: 8,
            type: TYPE.TEXT,
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
            disabled: (record: any) => !this.fieldsToUpdate.includes('contractList'),
          },
          {
            field: 'contractListInclude',
            column: 4,
            type: TYPE.CHECKBOX,
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
            disabled: (record: any) => !this.fieldsToUpdate.includes('contractListInclude'),
          },
          {
            field: 'accountCode',
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            optionValue: 'text',
            options: () => this.dataLoadingService.displayedAccounts,
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
            disabled: (record: any) => !this.fieldsToUpdate.includes('accountCode'),
            validate: record => this.validate(component)
          },
          {
            field: 'traderCode',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.dataLoadingService.traders,
            labelCheckbox: true,
            labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
            disabled: (record: any) => !this.fieldsToUpdate.includes('traderCode'),
          }]
      },
    ];
  }

  validate(component: BatchActionAccountTraderFormComponent): string {
    setTimeout(() => {
      let messagePart: string = ''
      if (!this.fieldsToUpdate.includes('customerName')
        && component.originOwner != component.formRecord.owner) {
        messagePart = 'Customer';
      }
      if (!this.fieldsToUpdate.includes('accountCode')
        && component.originOwner != component.formRecord.owner) {
        if (messagePart && messagePart.length > 0) messagePart += 'and '
        messagePart += 'Account';
      }
      messagePart && messagePart.length > 0 ?
        'Please check if ' + messagePart + ' exists for this new Owner.' : '';

    })
    return '';
  }

}
